<template lang="pug">
  v-dialog(v-model="show" max-width="500" scrollable :fullscreen="$vuetify.breakpoint.smAndDown" persistent)
    v-form(v-model="isFormValid" @submit.prevent="onSubmitButtonClick" ref="form" :disabled="loading" )
      v-card.d-flex.flex-column(flat)
        v-card-title.headline {{ $t('settingsPage.offerStructure.addNewSlot') }}
        v-card-text.pb-1.flex-shrink-0.flex-grow-1.card-body
            v-row.ma-0
              v-col(cols="12")
                v-text-field(outlined v-model="slotName" :label="$t('settingsPage.offerStructure.nameLabel')" :rules="nameRules" autofocus)
            v-row.ma-0
              v-col(cols="6")
                v-text-field(outlined v-model="slotCode" :label="$t('settingsPage.offerStructure.codeLabel')" :rules="codeRules" )
              v-col(cols="6")
                v-text-field(outlined v-model="referencePrice" type="number" :label="$t('settingsPage.offerStructure.amountLabel')" )
            v-row.ma-0
              v-col(cols="12")
                v-select.mb-0.text-center(
                  outlined
                  height="56px"
                  :items="tagList"
                  :label="$t('settingsPage.labelLabel')"
                  item-text="title"
                  item-value="id"
                  v-model="selections"
                  color="primary"
                  multiple
                  append-icon="fas fa-chevron-down"
                  chips
                  return-object
                )
                  template( v-slot:selection="{ item, index }")
                    v-chip()
                      v-icon.mr-4(left) {{getIcon(item.iconClass)}}
                      span {{item.title}}
                  template(v-slot:item="{active, item, attrs, on }")
                    v-list-item(v-on="on" v-bind="attrs" v-slot:default="{ active }")
                      v-list-item-action
                        v-checkbox(
                          :input-value="active"
                          on-icon="fas fa-check-square"
                          off-icon="far fa-square" )
                      v-list-item-content
                        v-list-item-title
                          v-icon.mr-4 {{getIcon(item.iconClass)}}
                          span {{item.title}}
        v-divider
        v-card-actions
          v-spacer
          v-btn( color="primary" text @click="onCancelButtonClick" :disabled="loading" ) {{ $t('optOutDialog.cancelButtonLabel') }}
          v-btn(color="primary" type="submit" :loading="loading" @click="onSubmitButtonClick" :disabled="!isFormValid") {{$t('optOutDialog.submitCreditButtonLabel') }}

</template>

<script lang="ts">

import {Component, Prop} from "vue-property-decorator";
import Vue from 'vue';
import i18n from "@/plugins/i18n";
import {SlotPayload} from "@/types/payload";
import Tag from "@/model/tennant/Tag";


@Component({})

export default class AddNewSlotDialog extends Vue {
  $refs!: {
    form: Vue & {
      validate(): boolean,
      resetValidation(): boolean
    }
  }

  @Prop({ type: Boolean, default: false }) readonly show!: boolean
  @Prop({ type: Boolean, default: false }) readonly loading!: boolean
  @Prop({ type: Array, required: false }) readonly tagList!: Tag[]


  private isFormValid: boolean = false
  private slotName: string = ''
  private nameRules: Array<(v:string) => string | boolean> = [
    (v:string) => !!v || i18n.t('settingsPage.offerStructure.nameValidationText').toString()
  ]
  private codeRules: Array<(v:string) => string | boolean> = [
    (v:string) => !!v || i18n.t('settingsPage.offerStructure.codeValidationText').toString()]
  private slotCode: string = ''
  private referencePrice: string = ''
  private selections: any[] = []


  getIcon (item: string):string | null {
    if(item && item.length > 4) {
      return item  ? `fas ${item}` : null
    } else {
      return ''
    }
  }

  onSubmitButtonClick (): void {
    let tagCollection = this.selections.map((i: Tag) => {
      return `/api/tag/${i.id}`
    })
    const payload: SlotPayload = {
      title: this.slotName,
      code: this.slotCode,
      referencePrice: this.referencePrice ? this.referencePrice : null,
      tags: tagCollection
    }
    this.$emit('save', payload)
  }

  onCancelButtonClick (): void {
    this.$emit('close')
  }

  mounted() {
    console.log(this.tagList)
  }

}

</script>

<style lang="stylus" scoped>

</style>
